import { render } from "./AlertIcon.vue?vue&type=template&id=5d9e1a28"
const script = {}
script.render = render

export default script